export default __webpack_public_path__ + "fonts/ai-search-unavailable.svg";